import { render, staticRenderFns } from "./chapterVideo.vue?vue&type=template&id=3cbeb957"
import script from "./chapterVideo.vue?vue&type=script&lang=js"
export * from "./chapterVideo.vue?vue&type=script&lang=js"
import style0 from "./chapterVideo.vue?vue&type=style&index=0&id=3cbeb957&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports